.fc{width:1rem;}